import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import BlogForm from '../components/forms/BlogForm'
import AdvertisementForm from '../components/forms/AdvertisementForm'
import DivisionForm from '../components/forms/DivisionForm'
import ShopForm from '../components/forms/ShopForm'
import SuperAdminAuthenticateForm from '../components/forms/SuperAdminAuthenticateForm'
import Authenticate from '../components/modals/Authenticate'
import ShopMoreDetails from '../components/modals/ShopMoreDetails'
import { fetchBlogs, fetchShops, fetchContactus, fetchDivisions, fetchAdvertisements } from '../redux/actions'
// import { fetchBlogs, fetchShops } from '../redux/actions'
// import { fetchDivisions } from '../redux/actions/division.actions'
import { StoreState } from '../redux/reducers'
import { AuthSuperAdmin } from '../redux/reducers/authSuperAdmin.reducer'
import { AppDispatch } from '../redux/store'
import { fetchCountReport } from '../redux/actions/countReport.actions'

export interface SuperAdminContextType {
    onMoreClick?: (shopId: string) => void
    onAddShop?: () => void
    onAddBlog?: () => void
    onAddDivision?: () => void
    onAddAdvertisement?: () => void
    onEditShop?: (shopId: string) => void
    onEditBlog?: (blogId: string) => void
    onEditDivision?: (divisionId: string) => void
    onEditAdvertisement?: (advertisementId: string) => void
}

export const SuperAdminContext = React.createContext<SuperAdminContextType | null>(null)

const SuperAdminProvider = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const superAdmin = useSelector<StoreState, AuthSuperAdmin | null>(state => state.authSuperAdmin)

    const isLoggedIn = superAdmin && superAdmin['auth-token'] !== ''

    const [showShopForm, setShowShopForm] = React.useState<boolean>(false)
    const [showBlogForm, setShowBlogForm] = React.useState<boolean>(false)
    const [showDivisionForm, setShowDivisionForm] = React.useState<boolean>(false)
    const [showAdvertisementForm, setShowAdvertisementForm] = React.useState<boolean>(false)


    const [showShopMoreDetails, setShowShopMoreDetails] = React.useState<boolean>(false)
    const [editShopId, setEditShopId] = React.useState<string | null>(null)
    const [editBlogId, setEditBlogId] = React.useState<string | null>(null)
    const [editDivisionId, setEditDivisionId] = React.useState<string | null>(null)
    const [editAdvertisementId, setEditAdvertisementId] = React.useState<string | null>(null)


    const onAddShop = () => setShowShopForm(true)
    const onAddBlog = () => setShowBlogForm(true)
    const onAddDivision = () => setShowDivisionForm(true)
    const onAddAdvertisement = () => setShowAdvertisementForm(true)

    const onEditShop = (shopId: string) => {
        setEditShopId(shopId)
        setShowShopForm(true)
    }
    const onEditBlog = (blogId: string) => {
        setEditBlogId(blogId)
        setShowBlogForm(true)
    }
    const onEditDivision = (divisionId: string) => {
        setEditDivisionId(divisionId)
        setShowDivisionForm(true)
    }
    const onEditAdvertisement = (advertisementId: string) => {
        setEditAdvertisementId(advertisementId)
        setShowAdvertisementForm(true)
    }

    const closeShopFormClickHandler = () => {
        setShowShopForm(false)
        setEditShopId(null)
    }
    const closeBlogFormClickHandler = () => {
        setShowBlogForm(false)
        setEditBlogId(null)
    }
    const closeDivisionFormClickHandler = () => {
        setShowDivisionForm(false)
        setEditDivisionId(null)
    }
    const closeAdvertisementFormClickHandler = () => {
        setShowAdvertisementForm(false)
        setEditAdvertisementId(null)
    }

    const closeShopMoreDetailsClickHandler = () => {
        setShowShopMoreDetails(false)
        setEditShopId(null)
    }

    const onMoreClick = (shopId: string) => {
        setEditShopId(shopId)
        setShowShopMoreDetails(true)
    }

    React.useEffect(() => {
        if (isLoggedIn) {
            dispatch(fetchShops())
            dispatch(fetchBlogs())
            dispatch(fetchContactus())
            dispatch(fetchDivisions())
            dispatch(fetchAdvertisements())
            dispatch(fetchCountReport())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn])

    return superAdmin
        ? <SuperAdminContext.Provider value={{ onAddShop, onEditShop, onMoreClick, onAddBlog, onEditBlog, onAddDivision, onEditDivision, onAddAdvertisement, onEditAdvertisement }}>
            {showShopForm && <ShopForm
                onClose={closeShopFormClickHandler}
                id={editShopId}
            />}
            {showBlogForm && <BlogForm
                onClose={closeBlogFormClickHandler}
                id={editBlogId}
            />}
            {showDivisionForm && <DivisionForm
                onClose={closeDivisionFormClickHandler}
                id={editDivisionId}
            />}
            {showAdvertisementForm && <AdvertisementForm
                onClose={closeAdvertisementFormClickHandler}
                id={editAdvertisementId}
            />}
            {showShopMoreDetails && <ShopMoreDetails
                onClose={closeShopMoreDetailsClickHandler}
                id={editShopId}
            />}
            <Outlet />
        </SuperAdminContext.Provider>
        : <Authenticate layout="classic" onClose={() => navigate("/")} >
            <SuperAdminAuthenticateForm />
        </Authenticate>
}

export default SuperAdminProvider